<template>
  <base-modal ref="modal" @hiding="reset">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-primary-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <mail-icon class="tw-h-6 tw-w-6 tw-text-primary-600" />
        </div>
        <div class="tw-w-full tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Create Contact</h3>
          <div class="tw-mt-8">
            <base-form ref="form" v-model="isFormValid">
              <base-select v-model="contactType" placeholder="Select a contact type" :options="contactTypeOptions" label="Contact Type" />
              <base-phone-number-input label="Phone" placeholder="Enter phone" v-model="phone" :e164.sync="phone164" required class="tw-mt-5" />
              <base-email-field label="Email Address" placeholder="Enter an email address" required v-model="email" class="tw-mt-2" />
            </base-form>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="createContact" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="primary">Create</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="primary">
          Cancel
        </base-button>
      </div>
      <inline-error id="create-contact-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import { MailIcon } from "@/assets/svgs";
import { mapActions } from "vuex";

export default {
  name: "CreateBusinessContact",
  props: {
    businessId: String,
  },
  components: {
    InlineError,
    MailIcon,
  },
  data() {
    return {
      isFormValid: true,
      isLoading: false,
      email: null,
      phone: null,
      phone164: null,
      contactType: null,
      contactTypeOptions: [{ value: "administration", label: "Administration" }, { value: "operations", label: "Operations" }],
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    ...mapActions("businessActivation", { initBusinessActivation: "init" }),
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
      this.email = null;
      this.phone = null;
      this.contactType = null;
    },
    createContact() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;

      this.$axios
        .post(`/businesses/${this.businessId}/contacts/`, {
          phone: this.phone164,
          email: this.email,
          contactType: this.contactType,
        })
        .then(() => {
          this.hide();
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Contact Added", message: "Your contact was created successfully" });
          this.$emit("created");
          this.initBusinessActivation();
        })
        .catch((err) => {
          this.errorTitle = `Failed to create contact`;
          this.errorMessage = `This contact was not able to be created. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
